// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1QEID","bigColWidth":"Table_bigColWidth__12uGU","biggerColWidth":"Table_biggerColWidth__1dKq5","row":"Table_row__2fkgd","col":"Table_col__2qiJ1"};